const GROUP_TYPES = {
  header: "header",
  container: "container",
  card: "card"
};
const FIELD_TYPES = {
  dateRange: "date_range",
  date: "date",
  select: "select",
  text: "text",
  hidden: "hidden",
  button: "button"
};
const COMPOSITE_FIELDS = {
  [FIELD_TYPES.dateRange]: "date_range"
};
const COMPONENT_TYPES = {
  TEXT: "text",
  SEMI_CIRCLE: "semi-circle",
  VALUE: "value",
  // TREND: 'trend',
  TREND_INDICATOR: "trend_indicator",
  TREND_WITH_ICON: "trend_with_icon",
  ICONS: "icons",
  TABLE: "table",
  LINE_CHART: "line_chart",
  BAR_CHART: "bar_chart",
  STACKED_BAR_CHART: "stacked_bar_chart",
  MIXED_CHART: "mixed_chart",
  PIE_CHART: "pie_chart",
  TEXT_BLOCK: "text_block",
  BANNER: "banner",
  CUSTOM: "custom_component",
  BARTREND: "funnel"
};
const CONFIG_LAYOUTS = {
  REPORT: "report",
  HERO_OVERVIEW: "hero_overview"
};
export {
  COMPONENT_TYPES,
  COMPOSITE_FIELDS,
  CONFIG_LAYOUTS,
  FIELD_TYPES,
  GROUP_TYPES
};
